import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import CheckCard from '../components/CheckCard/CheckCard';
import styles from './Learn.module.css';
import learnCardTexts from '../data/learnCardTexts.json';
import { Login as LoginIcon, Logout, Person, Close } from '@mui/icons-material';
import { auth } from '../utils/firebase';
import HeaderActions from '../components/Header/HeaderActions';

const Learn: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hospitalId } = useParams();
  const prefix = hospitalId ? `/${hospitalId}` : '';

  const isLoggedIn = auth.currentUser !== null;

  const [activeVideoId, setActiveVideoId] = useState<string | null>(null);

  const learns = Object.entries(learnCardTexts).map(([key, data]) => ({
    ...data,
    id: key
  }));
  
  const extractVideoId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const handleStart = (learn: any) => {
    if (learn.link) {
      // 유튜브 링크인 경우 내부 재생
      const videoId = extractVideoId(learn.link);
      if (videoId) {
        setActiveVideoId(videoId);
      } else {
        // 유튜브가 아니면 새 창 열기 (기존 글 등)
        window.open(learn.link, '_blank');
      }
    }
  };

  const handleMyInfo = () => {
    navigate(`${prefix}/my-info`);
  };

  const handleLoginClick = () => {
    navigate(`${prefix}/login`);
  };

  const handleLogout = async () => {
    const confirmLogout = window.confirm(t('logout_confirm', '로그아웃 하시겠습니까?'));
    if (confirmLogout) {
      await auth.signOut();
      localStorage.clear();
      navigate(`${prefix}/`);
    }
  };

  const closeVideo = () => {
    setActiveVideoId(null);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <span className={styles.logoText}>BrainCheck</span>
        </div>
        <HeaderActions hospitalId={hospitalId} />
      </div>

      <div className={styles.cardsContainer}>
        <div className={styles.cardsScroll}>
          {learns.map((learn) => (
            <CheckCard
              key={learn.id}
              titleKey={learn.titleKey}
              descriptionKey={learn.descriptionKey}
              timeKey={learn.timeKey}
              imageUrl={learn.imageUrl}
              onStart={() => handleStart(learn)}
            />
          ))}
        </div>
      </div>
      {activeVideoId && (
        <div className={styles.modalOverlay} onClick={closeVideo}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeButton} onClick={closeVideo}>
              <Close sx={{ color: 'white' }} /> 닫기
            </button>
            <iframe
              className={styles.videoFrame}
              src={`https://www.youtube.com/embed/${activeVideoId}?autoplay=1`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default Learn; 